import type { Psbt } from 'bitcoinjs-lib';
import type { InputToSign } from 'sats-connect';

import type { BitcoinSignPsbtRequest } from '../../BitcoinWalletProvider.types';
import { getSigHashType } from '../getSigHashType';
import { validatePsbt } from '../validatePsbt';

type GetPsbtInputsToSignForSatsConnectParams = {
  isLegacySatsConnect?: boolean;
  psbt: Psbt;
  request: BitcoinSignPsbtRequest;
};

/**
 * This method will create the psbt sign options for SatsConnect for the given request
 * It will validate the psbt against the signature data provided in the request
 * It will return the inputs to sign if the signature data is provided
 */
export const getPsbtInputsToSignForSatsConnect = ({
  psbt,
  request,
  isLegacySatsConnect,
}: GetPsbtInputsToSignForSatsConnectParams) => {
  if (!request.signature) {
    return [];
  }

  validatePsbt({
    allowedSigHashTypes: request.allowedSighash,
    psbt,
    signatureData: request.signature,
  });

  const inputsToSign: InputToSign[] = [];

  for (const signature of request.signature) {
    if (signature.signingIndexes?.length) {
      for (const index of signature.signingIndexes) {
        inputsToSign.push({
          address: signature.address,
          sigHash: isLegacySatsConnect
            ? getSigHashType({ input: psbt.data.inputs[index] })
            : request.allowedSighash[0],
          signingIndexes: [index],
        });
      }
    }
  }

  return inputsToSign;
};
